import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, DoCheck } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { ControlContainer, NgForm } from '@angular/forms';
import {  isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { Subject } from 'rxjs';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { confirmRemoveFromList } from '../../../_infrastructure/TableEdit/TableEditBase';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';

@Component({
    selector: 'clinical-situation',
    templateUrl: './clinical-situation.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class ClinicalSituationComponent implements OnInit, OnDestroy, ICardComponent {
  public cardData: models.ClinicalSituationVM = {} as models.ClinicalSituationVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;
  public isWorkflowMandatory: boolean = false;
  public isWorkflowPgpv: boolean = false;

  public disableTableRemoveIcons: boolean = false;

  public expandedRowIndex: number = null;
  public expandNewEntry: boolean = false;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];

  listChangeSubject = new Subject<string>();

  public preFilledItem: models.ClinicalSituationEntryVM = <models.ClinicalSituationEntryVM>{};

  constructor(private modalService: ModalService) {
  }

  ngOnInit(): void {
    if (isNullOrUndefined(this.cardData.incapacityList))
      this.cardData.incapacityList = [];
    else
      this.sortIncapacityList(this.cardData.incapacityList);
  }



  ngOnDestroy(): void {
  }

  excludeLineBreak(event: KeyboardEvent) {
    if (event.charCode === 10 || event.charCode===13) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  excludeLineBreak2(event: KeyboardEvent) {
    var txt = this.cardData.clinicalSubscDocObs;
    this.cardData.clinicalSubscDocObs = txt.replace(/\r/g, "").replace(/\n/g, "");
  }



  onIncapacityListChanged(newList: models.ClinicalSituationEntryVM[]): void {
    this.sortIncapacityList(newList);
    this.cardData.incapacityList = newList;
    this.expandedRowIndex = null;
    this.expandNewEntry = false;
    this.listChangeSubject.next("IncapacityListChanged");
  }

  sendDocChanged(): void {    
    if ((this.cardData.clinicalSubscDoc ?? "false").toString() == "true")
      this.cardData.clinicalSubscDocObs = "";
  }

  

  removeIncapacity(index: number, event: MouseEvent): void {
    if (this.expandedRowIndex == null || this.expandedRowIndex == index) {
      confirmRemoveFromList(this.cardData.incapacityList, index, this.modalService).subscribe(result => {
        this.expandedRowIndex = null;
        if (result)
          this.listChangeSubject.next("IncapacityListChanged");
      });
    }
    event.stopPropagation();
  }

  onExpandNewEntry(preFilledEntry: models.ClinicalSituationEntryVM = null): void {
    this.preFilledItem = isNullOrUndefined(preFilledEntry) ? <models.ClinicalSituationEntryVM>{} : { ...preFilledEntry };
    this.expandNewEntry = !this.expandNewEntry;
  }

  onCloseNewEntry() {
    this.preFilledItem = <models.ClinicalSituationEntryVM>{};
    this.expandNewEntry = !this.expandNewEntry;
  }

  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }

  sortIncapacityList(incapacityList: models.ClinicalSituationEntryVM[]) {
    incapacityList.sort((first, second) => second.diagnoseDate?.getTime() - first.diagnoseDate?.getTime());
  }
}
